const formattedTime = function(time, alternateFormat) {
    let hours = Math.floor(time / 3600);

    if (alternateFormat) {
        var minutes = (time - hours * 3600) / 60;
        if (hours > 0) {
            return `${hours}h ${pad(Math.round(minutes), 2)}m`;
        } else if (minutes > 1) {
            return `${Math.round(minutes)}m`;
        } else {
            var seconds = time % 60;
            return `${seconds}s`;
        }
    }

    minutes = Math.floor((time - hours * 3600) / 60);
    seconds = Math.floor(time % 60);
    if (hours > 0) {
        return `${hours}:${pad(minutes, 2)}:${pad(seconds, 2)}`;
    } else {
        return `${minutes}:${pad(seconds, 2)}`;
    }
};

const pad = (value, pad) => {
    var finalValue = String(value);
    while (finalValue.length < pad) {
        finalValue = '0' + finalValue;
    }
    return finalValue;
};

module.exports = {formattedTime};
